import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { useGetProjectHotelPMS } from "../../../hooks/project.hooks";
import { PMS_ALL_VALUE } from "../../../utils/pms.utils";

const { Option } = Select;

const ProjectPMSSelect = ({
  projectId,
  value,
  onChange,
  setProjectPMSListRef,
  all,
  ...rest
}) => {
  const { data: pmsDataSet, isLoading } = useGetProjectHotelPMS(projectId, {
    select: (data) => {
      const pmsList = [...data];
      return pmsList.sort((a, b) => a.pms_name.localeCompare(b.pms_name));
    },
  });

  useEffect(() => {
    onChange(undefined);
  }, [projectId]);

  useEffect(() => {
    if (setProjectPMSListRef !== undefined) {
      setProjectPMSListRef(pmsDataSet ?? []);
    }
  }, [pmsDataSet]);

  return (
    <Select
      placeholder="PMS"
      value={value}
      onChange={onChange}
      showSearch
      loading={isLoading}
      optionFilterProp="children"
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      {...rest}
    >
      {all && Array.isArray(pmsDataSet) && pmsDataSet.length > 1 && (
        <Option value={PMS_ALL_VALUE}>All</Option>
      )}
      {Array.isArray(pmsDataSet) &&
        pmsDataSet.map((pms) => (
          <Option value={pms._id} key={pms._id}>
            {pms.pms_name}
          </Option>
        ))}
    </Select>
  );
};

ProjectPMSSelect.defaultProps = {
  value: undefined,
  projectId: undefined,
  all: true,
  onChange: () => {},
  setProjectPMSListRef: undefined,
};

ProjectPMSSelect.propTypes = {
  projectId: PropTypes.string,
  value: PropTypes.string,
  all: PropTypes.bool,
  onChange: PropTypes.func,
  setProjectPMSListRef: PropTypes.func,
};

export default ProjectPMSSelect;
